<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author YuJiaBei
    // Date 2021-01-19 14:37:04

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "sithMesMstUserLocationEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        }
    };
</script>